import React, { useState, useRef, useEffect } from "react";
import Menu from "../Menu/Menu";

type Props = {};

const MenuButton = (props: Props) => {
  let [isActive, setIsActive] = useState(false);
  const handleOnClick = () => {
    setIsActive((prevState) => !prevState);

  };
  const navRef = useRef<HTMLButtonElement>(null);
  const [transformOrigin, setTransformOrigin] = useState("50% 50%");

  let onClickMenuItem = () => {
    setIsActive(false);
  };
  useEffect(() => {
    const updateTransformOrigin = () => {
      if (navRef.current) {
        const rect = navRef.current.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        // Set the transform origin based on the calculated center
        setTransformOrigin(`${centerX}px ${centerY}px`);
      }
    };

    // Update transform origin when the component mounts and when the nav becomes active
    updateTransformOrigin();

    // Optionally, listen to resize events to recalculate the center if the window is resized
    window.addEventListener("resize", updateTransformOrigin);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateTransformOrigin);
    };
  }, [isActive]);
  return (
    <div className="rounded-xl overflow-clip">
      <button
        ref={navRef}
        onClick={handleOnClick}
        className="group relative z-10 h-12 w-12 md:h-16 md:w-16 bg-white/0 transition-all hover:bg-white/20 rounded-xl"
      >
        <div
          className="block w-5 md:w-8 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
          // Toggle the isActive state on click
        >
          <span
            aria-hidden="true"
            className={`block absolute h-0.5 w-5 md:h-0.8 md:w-8 rounded-full bg-white transform transition duration-500 ease-in-out ${
              isActive ? "rotate-45" : "-translate-y-1.5"
            }`}
            
          ></span>
          <span
            aria-hidden="true"
            className={`block absolute h-0.5 w-5 md:h-0.8 md:w-8 rounded-full bg-white transform transition duration-500 ease-in-out ${
              isActive ? "opacity-0" : ""
            }`}
           
          ></span>
          <span
            aria-hidden="true"
            className={`block absolute h-0.5 w-5 md:h-0.8 md:w-8 rounded-full bg-white transform transition duration-500 ease-in-out ${
              isActive ? "-rotate-45" : "translate-y-1.5"
            }`}
            
          ></span>
        </div>
      </button>

      <Menu
        isActive={isActive}
        transfromOrigin={transformOrigin}
        onClickMenuItem={onClickMenuItem}
      />
    </div>
  );
};

export default MenuButton;
